import React, { useState } from 'react';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveVerificationTab } from '../../containers/app-container/reducer/filterSlice';

function HeaderStats({ stats, onFilterChange }) {
  const activeTab = useSelector((state) => state.filter.activeVerificationTab);
  const dispatch = useDispatch();
  const setActiveTab = (value) => {
    dispatch(setActiveVerificationTab({ activeVerificationTab: value }));
  };

  // Handle tab click and pass the selected status to the parent
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    let statusFilter = '';
    if (tab === 'Total Verification Requests') statusFilter = 'Total Verification Requests';
    else if (tab === 'Approved Requests') statusFilter = 'Approved';
    else if (tab === 'Rejected Requests') statusFilter = 'Rejected';
    else if (tab === 'Pending Requests') statusFilter = 'Pending';
    else statusFilter = ''; // Show all for Total Verification Requests

    onFilterChange(statusFilter);
  };

  // status filter inside redux...

  return (
    <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
      {stats.map((stat, index) => {
        // Dynamically calculate the total count
        const total = stat.idCount + stat.selfieCount;

        return (
          <div
            key={index}
            onClick={() => handleTabChange(stat.title)} // Handle tab switch on click
            style={{
              padding: '15px',
              border:
                activeTab === stat.title
                  ? '1px solid #ff4A4A'
                  : '1px solid #ddd',
              borderRadius: '8px',
              width: '100%',
              textAlign: 'left',
              cursor: 'pointer',
              backgroundColor:
                activeTab === stat.title ? 'rgb(255, 74, 74, 0.02)' : '#fff',
            }}
          >
            <div
              className="font-14 fw-medium color75 text-uppercase d-flex align-items-start gap-1"
              style={{ margin: '5px 0', lineHeight:'18px', }}
            >
              <FiberManualRecordIcon
                sx={{
                  width: '16px',
                  height: '16px', mt:0.2,
                  color: stat.fixedColor, // Set a fixed color for the icon
                }}
              />{' '}
              {stat.title} 
            </div>

            {/* Total Count */}
            <p className="fw-bold text-black font-18 my-6 totalCountValue">
              {total}
            </p>
            {/* ID Count */}
            <p
              className="d-flex justify-content-between align-items-center font-12 fw-medium"
              style={{ margin: '5px 0', color: '#888' }}
            >
              {stat.idverification}{' '}
              <span className="idCountValue text-black">{stat.idCount}</span>
            </p>
            {/* Selfie Count */}
            <p
              className="d-flex justify-content-between align-items-center font-12 fw-medium"
              style={{ margin: '5px 0', color: '#888' }}
            >
              {stat.selfieverification}{' '}
              <span className="selfieCountValue text-black">
                {stat.selfieCount}
              </span>
            </p>
          </div>
        );
      })}
    </div>
  );
}

export default HeaderStats;
